module.exports = __webpack_public_path__ + "static/media/The-barefoot-doctor-who-has-cause-a-1000-healthy-smiles.3aca6806.pdf";